import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MeldingPage.css';

function MeldingPage() {
  const [accessCode, setAccessCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (accessCode === 'MTBcash$') {
      navigate('/krabbypattyformula');
    } else {
      setError('Incorrect password');
    }
  };

  const handleCommunityAccess = () => {
    navigate('/bringerofworlds');
  };

  return (
    <div className="melding-page">
      <div className="login-container">
        <div className="founder-quote">
          <p>"Through the fusion of movement and rhythm, we discover our true potential."</p>
          <span className="founder-name">- Michael Ding, Founder</span>
        </div>
        <div className="community-link" onClick={handleCommunityAccess}>
          Access Community
        </div>
        <form onSubmit={handleSubmit}>
          <label className="login-label">
            MTB.V0 Access Code
          </label>
          <input
            type="password"
            className="login-input"
            value={accessCode}
            onChange={(e) => {
              setAccessCode(e.target.value);
              setError('');
            }}
            placeholder="Enter access code"
            autoComplete="off"
          />
          {error && <div className="error-message">{error}</div>}
        </form>
      </div>
    </div>
  );
}

export default MeldingPage;

